/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Company } from './Company'
import type { Professional } from './Professional'
import type { Users_Permissions_User } from './Users_Permissions_User'
export type Message = {
  id?: number
  content: string
  company?: Company
  professional?: Professional
  initiator?: Message.initiator
  receiverRead?: boolean
  receiverNotified?: boolean
  createdAt?: string
  updatedAt?: string
  createdBy?: Users_Permissions_User
  updatedBy?: Users_Permissions_User
}
export namespace Message {
  export enum initiator {
    PROFESSIONAL = 'professional',
    COMPANY = 'company',
  }
}
